import appIcon from 'virtual:app-icon'
import { useTexte } from '../texte'

/**
 * What stands there while the app is being built (1.79.0): the app symbol and
 * a running bar.
 *
 * From use: "Neustart der App bei schlechtem Netz. nur weißer Bildschirm, bis
 * er dann nach einigen Sekunden lädt. irgendein Hinweis am Bildschirm, ein
 * laufender Balken etc."
 *
 * **The same markup stands in `index.html`**, inside `#root`, because there
 * it is on screen before React runs; React replaces it with its first render.
 * This component is the same picture for the time after that, while the
 * account is being asked for (`App`, `me.isPending`) -- so that nothing jumps
 * between the shell and the app. The two differ in one attribute:
 * `data-start="huelle"` there, `"app"` here. The outer error boundary in
 * `index.html` reacts only to the first -- a slow answer from the server is
 * not a bundle that failed to start.
 *
 * The symbol is a `data:` address and needs no request (1.117.0,
 * `appIcon()` in `vite.config.ts`): in a dead spot `/icon.svg` failed and
 * the start display showed a broken picture.
 */
export function Startanzeige() {
  const t = useTexte().rahmen
  return (
    <div className="startanzeige" data-start="app" role="progressbar" aria-label={t.startLaedt}>
      <img className="startanzeige__symbol" src={appIcon} alt="" width={72} height={72} />
      <span className="startanzeige__balken" />
    </div>
  )
}
